import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/api';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Auth.css';

const Login: React.FC = () => {
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { t } = useLanguage();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await authService.login(formData);
            if (response.success) {
                // Redirecionar para UserCP após login bem-sucedido
                navigate('/usercp');
            } else {
                setError(response.message || 'Login failed');
            }
        } catch (err: any) {
            setError(err.response?.data?.message || 'An error occurred during login');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <h1>{t('auth.login')}</h1>
                    <p>{t('auth.loginSubtitle')}</p>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    {error && <div className="error-message">{error}</div>}

                    <div className="form-group">
                        <label htmlFor="username">{t('auth.username')}</label>
                        <input
                            type="text"
                            id="username"
                            value={formData.username}
                            onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                            required
                            placeholder={t('auth.enterUsername')}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">{t('auth.password')}</label>
                        <input
                            type="password"
                            id="password"
                            value={formData.password}
                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                            required
                            placeholder={t('auth.enterPassword')}
                        />
                    </div>

                    <button 
                        type="submit" 
                        className={`btn btn-primary btn-xl ${loading ? 'btn-loading' : ''}`}
                        disabled={loading}
                    >
                        {loading ? t('auth.loggingIn') : t('auth.login')}
                    </button>
                </form>

                <div className="auth-footer">
                    <p>{t('auth.noAccount')} <Link to="/register">{t('auth.registerHere')}</Link></p>
                </div>
            </div>
        </div>
    );
};

export default Login;
